'use client';

import { ReactNode } from 'react';

import { Title, TitleLevels, TitleMarkup, TypographyAlign } from '@bytel/trilogy-react';

import { SSIBlock } from './ssi-block';

type FaqProps = {
    id: string;
    url: string;
    title: string | ReactNode;
    titleAlt?: string;
};

function FaqContainer({
    title,
    titleAlt,
    children,
}: {
    title: string | ReactNode;
    titleAlt?: string;
    children: ReactNode;
}) {
    return (
        <>
            <Title
                markup={TitleMarkup.H2}
                level={TitleLevels.TWO}
                typo={TypographyAlign.TEXT_CENTERED}
                accessibilityLabel={titleAlt}
            >
                {title}
            </Title>
            {children}
        </>
    );
}

export function Faq({ id, url, title, titleAlt }: FaqProps) {
    return <SSIBlock tagId={id} url={url} container={FaqContainer} containerProps={{ title, titleAlt }} />;
}
